<div class="row page-title">
  <span>{{ localizationConstants.REMINDERS_PAGE_TITLE | translate }}</span>
</div>

<div class="row">
  <div class="c-details col">
    <table class="o-list-table o-list-table--thin o-list-table--even full-width--mobile">
      <tr class="o-list-table__item">
        <td class="o-list-table__button">
          <button
            type="button"
            class="button button-primary button-block u-mobile"
            (click)="create()"
            [disabled]="allRemindersCreated"
            [attr.title]="(allRemindersCreated ? 'reminders.allreminderscreated' : '') | translate">
            {{ "reminders.createnew" | translate }}
          </button>
          <button
            type="button"
            class="button--sm button-primary u-tablet"
            (click)="create()"
            [disabled]="allRemindersCreated"
            [attr.title]="(allRemindersCreated ? 'reminders.allreminderscreated' : '') | translate">
            {{ "reminders.createnew" | translate }}
          </button>
        </td>
        <td class="o-list-table__button">
          <button
            type="button"
            class="button button-secondary button-block u-mobile"
            (click)="createDefaults()"
            [disabled]="allRemindersCreated"
            [attr.title]="(allRemindersCreated ? 'reminders.allreminderscreated' : '') | translate">
            {{ "reminders.createdefault" | translate }}
          </button>
          <button
            type="button"
            class="button--sm button-secondary u-tablet"
            (click)="createDefaults()"
            [disabled]="allRemindersCreated"
            [attr.title]="(allRemindersCreated ? 'reminders.allreminderscreated' : '') | translate">
            {{ "reminders.createdefault" | translate }}
          </button>
        </td>
      </tr>
    </table>
  </div>
</div>

<div
  *ngIf="isLoading"
  class="row center">
  <div class="col">
    <app-loading-icon
      class="u-color--light"
      size="2x"></app-loading-icon>
  </div>
</div>
<div
  [hidden]="dataSource.data?.length"
  class="row center">
  <div class="col">
    <h2>{{ "reminders.noremindersfound" | translate }}</h2>
  </div>
</div>
<div
  class="row"
  [hidden]="!dataSource.data?.length">
  <div class="col">
    <div class="u-scroll--horizontal">
      <div class="col">
        <table
          mat-table
          matSort
          [dataSource]="dataSource"
          class="c-table">
          <ng-container
            *ngFor="let col of columns"
            [matColumnDef]="col.key">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef>
              {{ col.title | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let r">
              <ng-container [ngSwitch]="col.key">
                <div *ngSwitchCase="'type'">
                  {{ r.type | reminder: "type" | translate }}
                </div>
                <div *ngSwitchCase="'interval'">
                  {{ r.interval | reminder: "interval" | translate }}
                </div>
                <div *ngSwitchCase="'daysBefore'">
                  {{ r.daysBefore }}
                </div>
                <div *ngSwitchCase="'daysAfter'">
                  {{ r.daysAfter }}
                </div>
                <div *ngSwitchCase="'to'">
                  <div
                    *ngFor="let address of r.to | split: ';'"
                    class="c-chip">
                    {{ address }}
                  </div>
                </div>
                <div *ngSwitchCase="'cc'">
                  <div
                    *ngFor="let address of r.cc | split: ';'"
                    class="c-chip">
                    {{ address }}
                  </div>
                </div>
                <div *ngSwitchCase="'bcc'">
                  <div
                    *ngFor="let address of r.bcc | split: ';'"
                    class="c-chip">
                    {{ address }}
                  </div>
                </div>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="action1">
            <th
              mat-header-cell
              *matHeaderCellDef></th>
            <td
              mat-cell
              *matCellDef="let r">
              <button
                type="button"
                class="button--sm button-primary button-block"
                (click)="openModal(r)">
                {{ "button.edit" | translate }}
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="action2">
            <th
              mat-header-cell
              *matHeaderCellDef></th>
            <td
              mat-cell
              *matCellDef="let r">
              <button
                type="button"
                class="button--sm button-secondary button-block"
                (click)="onRemoveReminder(r)"
                [disabled]="r.pending">
                <app-loading-icon *ngIf="r.pending"></app-loading-icon>
                <span *ngIf="!r.pending">{{ "button.delete" | translate }}</span>
              </button>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="columnKeysAll"></tr>
          <tr
            mat-row
            *matRowDef="let r; columns: columnKeysAll; let i = index"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
